<template>
  <v-container fluid>
    <BreadHeader
      :title="`New ${
        childModel.name[parentModel.key]
          ? childModel.name[parentModel.key].singular
          : childModel.name.singular
      }`"
    />
    <BreadTabulatorForm
      :isLoading="apiReadParent.isLoading"
      ref="form"
      action="add"
      :api="api"
      :model="childModel"
      :parentModel="parentModel"
    />
  </v-container>
</template>

<script>
import Api from "@/objects/api";
import BreadcrumbTabulator from "@/objects/breadcrumbTabulator";
import Model from "@/objects/model";
import Service from "@/objects/service";
import { mapState } from "vuex";

export default {
  computed: mapState({
    services: (state) => state.service.data.services,
  }),
  data: () => ({
    api: new Api(),
    apiReadParent: new Api(),
    breadcrumbTabulator: new BreadcrumbTabulator(),
    childModel: new Model(),
    parentModel: new Model(),
    parentModelId: null,
    service: new Service(),
    childService: new Service(),
    apiStoreUrl: "",
  }),
  created() {
    this.parentModel.getByKey(this.$route.params.parentModelKey);
    this.parentModelId = this.$route.params.parentModelId;
    this.childModel.getByKey(this.$route.params.childModelKey);
    if (this.parentModel.serviceKey)
      this.service.set("key", this.parentModel.serviceKey);

    if (this.childModel.serviceKey)
      this.childService.set("key", this.childModel.serviceKey);

    this.breadcrumbTabulator.addForOperationChildAdd({
      services: this.services,
      parentModel: this.parentModel,
      parentModelId: this.parentModelId,
      childModel: this.childModel,
    });
    this.apiReadParent.setUrl(
      `${this.$service[this.service.key]}/v1/en/console/tabulator/model/${
        this.parentModel.key
      }/${this.parentModelId}/read`,
    );
    this.apiReadParent.setCallbackCompleted((resp) => {
      var data = {
        [this.$_ucfirst(this.parentModel.key)]: resp,
      };
      this.$refs.form.setData(data);
    });
    this.apiReadParent.fetch();

    if (this.childModel.apiUrls.apiStoreUrl != "") {
      this.apiStoreUrl = `${this.$service[this.childService.key]}${
        this.childModel.apiUrls.apiStoreUrl
      }`;
    } else {
      this.apiStoreUrl = `${
        this.$service[this.childService.key]
      }/v1/en/console/tabulator/model/${this.childModel.key}/add`;
    }

    this.api.setMethod(`POST`);
    this.api.setUrl(this.apiStoreUrl);
    this.api.setCallbackCompleted(() => {
      this.$router.push({
        name: "PageServiceModelBreadTabulatorRead",
        query: {
          tab: this.childModel.key,
        },
        params: {
          serviceKey: this.parentModel.serviceKey,
          modelKey: this.parentModel.key,
          modelId: this.parentModelId,
        },
      });
      this.$store.dispatch("showMessage", {
        message: "Created successfully.",
        messageType: "success",
        timeout: 2000,
      });
    });
  },
};
</script>
